/**
 * @generated SignedSource<<db2532d16052e6c1b32a1c8615865476>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuImageGalleryPaginator_ProductSkuImageConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly urlFullSize: string;
    };
  }>;
  readonly " $fragmentType": "ProductSkuImageGalleryPaginator_ProductSkuImageConnection";
};
export type ProductSkuImageGalleryPaginator_ProductSkuImageConnection$key = {
  readonly " $data"?: ProductSkuImageGalleryPaginator_ProductSkuImageConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuImageGalleryPaginator_ProductSkuImageConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuImageGalleryPaginator_ProductSkuImageConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuImage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": "urlFullSize",
              "args": [
                {
                  "kind": "Literal",
                  "name": "size",
                  "value": 2000
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(size:2000)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuImageConnection",
  "abstractKey": null
};

(node as any).hash = "1041dc5115db5553ebcf9bf92ac655d5";

export default node;
